<template>
  <div id="container">
    <ul>
      <li v-for="(item, index) in items" :key="item.name">
        <div :class="{'highlighted': index === highlightedIndex}" class="list-item" @click="itemClicked(item, index)">
          {{ item.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "BizList",
    data() {
      return {
        items: [],
        highlightedCell: null,
        highlightedIndex: 0
      }
    },
    mounted() {
      this.$root.$on('updateBizList', data => {
        this.highlightedIndex = 0
        this.items = data
        this.$root.$emit('updateBizInfo', this.items[0])
      })
    },
    methods: {
      itemClicked(item, index) {
        this.highlightedIndex = index
        this.$root.$emit('updateBizInfo', item)
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: white;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .3);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }
  ul {
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  li {
    list-style-type: none;
    cursor: pointer;
  }
  li:hover {
    background-color: #232A2E;
    color: white;
  }
  .list-item {
    font-family: "Avenir Next", openSans, serif;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    padding: 12px 10px;
  }
  .highlighted {
    background-color: #232A2E;
    color: white;
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    .list-item {
      font-size: 12px;
      padding: 8px 10px;
    }
  }
</style>